import $ from 'jquery';

export const mainDelay = 150;

/**
 * Recursive function to expand all parents in given parents array
 */
function expandParent(parentElts, index, expand, noAnimation) {
  if (parentElts && parentElts[index]) {
    var $parentEl = $(parentElts[index]);
    if ($parentEl) {
      var parentCurH = $parentEl.height();
      var parentAutoH = $parentEl.css('height', 'auto').height();
      expandParent(parentElts, ++index, expand, noAnimation);
      if (noAnimation) {
        $parentEl.height(parentAutoH);
      } else {
        $parentEl.height(parentCurH).animate({height: parentAutoH}, mainDelay, 'easeInOutSine');
      }
    }
  }
}

/** Expand the dropdown content of a settings item
 * @Param expand: boolean to expand or un-expand
 * @Param $el: dom elt as a jquery instance
 * @Param parentElts: if set, also expand / unexpand parent elts
 */
function expandSettingsItem(expand, $el, parentElts, noAnimation) {
  let currentHeight, targetHeight;
  if (expand) {
    // Expand
    currentHeight = $el.height();
    targetHeight = $el.css('height', 'auto').height();
    expandParent(parentElts, 0, expand);
  } else {
    // Unexpand
    currentHeight = $el.height();
    targetHeight = 0;
    $el.height(0);
    expandParent(parentElts, 0, expand);
  }
  if (noAnimation) {
    $el.height(targetHeight);
  } else {
    $el.height(currentHeight).animate({ height: targetHeight }, mainDelay, 'easeInOutSine');
  }
}

/**
 * Expand an item with a 'expanded' attribut to the 'item' param
 * @Param id: id string of the element to expand. If not set, use the 'id' attribute of the item param
 * @Param parentId: array of parent ids oredered if
 *                  the parent(s) need(s) to be resized after the expansion
 */
export function itemExpand(item, id, parentIds, noAnimation) {
  const eltId = id || item.id;
  item.expanded = !item.expanded;
  expandSettingsItem(item.expanded, $(`#${eltId}`), (parentIds || []).map(id => $(`#${id}`)), noAnimation);
}

/**
 * Same as above without ids, params are DOM elts
 * @param  {Boolean} doExpand - Expand or not
 * @param  {Element} elt - DOM elt to expand
 * @param  {Array} parentElts - parent elts to also expand
 * @param  {Booelan} noAnimation - whether the expansion should be instant or not
 */
export function itemExpandElt(doExpand, elt, parentElts, noAnimation = false) {
  expandSettingsItem(doExpand, $(elt), parentElts, noAnimation);
}

export default {
  itemExpand,
  itemExpandElt,
};
